export default __webpack_public_path__ + "static/media/vrf4.06efce77.png";